import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { ensureReimaginedStylesLoaded } from 'tio-employee/utils/reimagined/ensure-styles';

/**
 * TIO Reimagined Parent Route
 *
 * This route serves as the container for the reimagined unified
 * financial wellness experience. Child routes include:
 * - /reimagined/home - Unified dashboard
 * - /reimagined/loans - Loans management
 * - /reimagined/benefits - Benefits hub

 */
export default class AuthenticatedReimagined extends Route {
  beforeModel(transition: Transition) {
    // Every /reimagined/* route nests under this one (app/router.ts), so
    // this is the single entry point for loading the prototype's CSS —
    // see ensure-styles.ts for why it isn't a build-time @import.
    ensureReimaginedStylesLoaded();
    return super.beforeModel(transition);
  }
}
